import React from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import swal from "sweetalert";
import {
  deletMonitoreoActividad,
  getMonitoreoActividad,
  getMonitoreosActividad,
} from "./../../redux/actions/monitoreo-actividad-actions";

const Monitoreo = (props) => {
  const {
    monitoreoId,
    trimestre,
    nivelEjecucion,
    fecha,
    fechaCreacion,
    justificacionDeNoCumplimiento,
    creadoPor,
    areaOrganizacional,
    comentarioHistorial
  } = props.monitoreoActividad;
  
  const monitoreoMediosVerificacion = props.monitoreoMediosVerificacion;

  const { actividadId, statusEditar, poaMonitoreo } = props;
  const tieneComentarioHistorial =
    typeof comentarioHistorial === "string" && comentarioHistorial.trim().length > 0;
  const monitoreoDevuelto =
    tieneComentarioHistorial &&
    comentarioHistorial.toLowerCase().includes("fue devuelto");
  const nivelAprobacionMonitoreo = Number(
    props.monitoreoActividad.nivelAprobacionId
  );
  console.log(nivelAprobacionMonitoreo)
  const nivelAprobacionUsuario = Number(
    props.user.nivelAprobacion.nivelAprobacionId
  );
  const nivelAprobacionPadre = Number(props.user.nivelAprobacion.padre);
  const monitoreoTieneNivelAprobacion =
    props.monitoreoActividad.nivelAprobacionId != null;
  const monitoreoFueEditadoTrasDevolucion =
    props.monitoreoActividad.envio === false ||
    props.monitoreoActividad.envio === "false";
  const monitoreoEnviado =
    nivelAprobacionMonitoreo === 4 && !monitoreoFueEditadoTrasDevolucion;
  const monitoreoDevueltoPendienteDeEnvio =
    monitoreoDevuelto && !monitoreoEnviado;
  const monitoreoDevueltoPendienteDeEdicion =
    monitoreoDevueltoPendienteDeEnvio &&
    !monitoreoFueEditadoTrasDevolucion &&
    nivelAprobacionMonitoreo !== nivelAprobacionUsuario;
  const monitoreoBloqueadoPorAprobacion =
    monitoreoEnviado ||
    (!monitoreoDevueltoPendienteDeEnvio &&
      monitoreoTieneNivelAprobacion &&
      nivelAprobacionMonitoreo !== nivelAprobacionUsuario);
  const monitoreoNoEditablePorUsuario =
    monitoreoBloqueadoPorAprobacion || monitoreoDevueltoPendienteDeEdicion;

  const eliminarMonitoreoActividad = () => {
    swal({
      title:`Está seguro de querer eliminar el monitoreo del trimestre ${props.monitoreoActividad.trimestre}?`,
      text: "Una vez eliminado no podrá recuperarse!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((confirm)  =>  {
      if (confirm) {
        let obj = {
          monitoreoActividadId: props.monitoreoActividad.monitoreoId,
          actividadId: props.actividadId,
          monitoreoMediosVerificacion:
            props.monitoreoMediosVerificacion,
        };
        window.location.reload();
        props.deletMonitoreoActividad(obj);
       
      }
    });
  };

  const validarStatus = () => {
    const value = (poaMonitoreo || []).find(
      (statusMonitoreo) =>
        Number(statusMonitoreo.trimestreId) === Number(trimestre)
    );

    return value ? !value.status : false;
  };

  const validarNivelAprobacion = () => {
    return monitoreoNoEditablePorUsuario;
  };

  return (
    <tr>
      <td>{trimestre}</td>
      <td>{nivelEjecucion}</td>
      <td>
        {
          <Moment format="DD/MM/YYYY">
            {fecha !== null ? fecha : fechaCreacion}
          </Moment>
        }
      </td>
      <td>
        <i
          className=" btn fas fa-cloud-download-alt"
          onClick={(e) => {
            e.preventDefault();
            props.activarModalArchivos(
              monitoreoMediosVerificacion,
              validarStatus() || validarNivelAprobacion(),
              justificacionDeNoCumplimiento
            );
          }}
        />
      </td>
      {props.activarModalNotaDevolucion && (
        <td>
          {monitoreoDevuelto ? (
            <i
              className=" btn fas fa-comment-dots"
              onClick={(e) => {
                e.preventDefault();
                props.activarModalNotaDevolucion(props.monitoreoActividad);
              }}
            />
          ) : (
            "-"
          )}
        </td>
      )}

      <td>
        <button
          onClick={(e) => {
            e.preventDefault();
            props.enviarMonitoreo(props.monitoreoActividad, props.actividadId);
          }}
          disabled={
            validarStatus() ||
            validarNivelAprobacion() ||
            monitoreoDevueltoPendienteDeEdicion
          }
          className="btn btn-success btn-sm"
          title={
            validarStatus()
              ? "El trimestre se ecuentra cerrado"
              : monitoreoDevueltoPendienteDeEdicion
              ? "El monitoreo fue devuelto al nivel correspondiente"
              : validarNivelAprobacion()
              ? "El trimestre fue enviado"
              : ""
          }
        >
          {props.monitoreoActividad.nivelAprobacionId == null
            ? "Enviar"
            : monitoreoEnviado
            ? "Enviado"
            : monitoreoDevueltoPendienteDeEnvio
            ? "Enviar"
            : nivelAprobacionMonitoreo > nivelAprobacionPadre
            ? "Aprobado"
            : nivelAprobacionMonitoreo === nivelAprobacionUsuario
            ? "Enviar"
            : "Enviado"}
        </button>
        {props.user.nivelAprobacion.nivelAprobacionId === 2 &&
          creadoPor.name !== props.user.nombre && (
            <button
              className="btn btn-sm btn-primary"
              onClick={(e) => {
                e.preventDefault();
                props.activarModalDevolucionMonitoreo(props.monitoreoActividad);
              }}
              disabled={validarStatus() || validarNivelAprobacion()}
              title={
                validarStatus()
                  ? "El trimestre se ecuentra cerrado"
                  : validarNivelAprobacion()
                  ? "El trimestre fue enviado"
                  : ""
              }
            >
              Devolver
            </button>
          )}

        {validarStatus() ? (
          <button
            onClick={(e) => e.preventDefault()}
            className="btn btn-info btn-sm opacity"
            title="El trimestre se ecuentra cerrado"
          >
            Editar
          </button>
        ) : validarNivelAprobacion() ? (
          <button
            onClick={(e) => e.preventDefault()}
            className="btn btn-info btn-sm opacity"
            title={
              monitoreoDevueltoPendienteDeEdicion
                ? "El monitoreo fue devuelto al nivel correspondiente"
                : "El trimestre se encuentra enviado"
            }
          >
            Editar
          </button>
        ) : (
          <Link
            to={{
              pathname: `/admin/monitoreo/actividad/${actividadId}/editar/${monitoreoId}`,
              state:
                "/admin/monitoreo/actividad/:actividadId/editar/:monitoreoActividadId",
            }}
            className="btn btn-sm btn-info"
          >
            Editar
          </Link>
        )}

        <button
          onClick={(e) => {
            e.preventDefault();
            eliminarMonitoreoActividad();
          }}
          className="btn btn-sm btn-danger"
          disabled={validarStatus() || validarNivelAprobacion()}
          title={
            validarStatus()
              ? "El trimestre se ecuentra cerrado"
              : validarNivelAprobacion()
              ? "El trimestre fue enviado"
              : ""
          }
        >
          Eliminar
        </button>
      </td>
    </tr>
  );
};

export default connect(null, {
  deletMonitoreoActividad,
  getMonitoreoActividad,
  getMonitoreosActividad,
})(Monitoreo);
